import $ from 'jquery';
import Swal from 'sweetalert2';

export default function() {
    $('.js-preview-product').on('click', function(e) 
    {
        e.preventDefault();
        const $productWrapper = $(this).closest('.ps-product--inner');
        window.waitMe($productWrapper);
        
        const productid = $(this).data('product-id');

        if(productid)
        {
            $.ajax({
                url: window.GLOBALS.baseLink + 'u/preview',
                type: 'GET',
                data: {ProductID: productid },
                dataType: 'json',
                success: function (response) {
                    if (response) {
                        if (response.IsSuccess) {
                            $('#product-quickview').modal('show');
                            window.closeWaitMe($productWrapper);
                            window.waitMe($('#product-quickview .modal-content'));

                            // product data binding
                            $('#product-quickview').find('.js-preview-modal-image').attr('src', response.Product.Image);
                            $('#product-quickview').find('.js-preview-modal-title').text(response.Product.Title);
                            $('#product-quickview').find('.js-preview-modal-brand').attr('href', '#').text(response.Product.Brand);
                            $('#product-quickview').find('.js-preview-modal-price').text(response.Product.Price + 'TL');
                            $('#product-quickview').find('.js-preview-modal-add-basket').attr('data-product-id', response.Product.ProductID);

                            window.closeWaitMe($('#product-quickview .modal-content'));
                        } else {
                            window.closeWaitMe($productWrapper);
                        }
                    }
                }
            })
        }

    });
}